export type Role = 'mafia_don' | 'mafia' | 'doctor' | 'detective' | 'prostitute' | 'civilian';

export type RoleDisplayName =
  | 'Дом мафии'
  | 'Мафия'
  | 'Доктор'
  | 'Комиссар'
  | 'Путана'
  | 'Мирный';

export const ROLE_TEAM: Record<Role, 'mafia' | 'town'> = {
  mafia_don: 'mafia',
  mafia: 'mafia',
  doctor: 'town',
  detective: 'town',
  prostitute: 'mafia',
  civilian: 'town',
};

export const ROLE_DISPLAY_NAME: Record<Role, RoleDisplayName> = {
  mafia_don: 'Дом мафии',
  mafia: 'Мафия',
  doctor: 'Доктор',
  detective: 'Комиссар',
  prostitute: 'Путана',
  civilian: 'Мирный',
};

export const ROLE_DESCRIPTION: Record<Role, string> = {
  mafia_don:
    'Главный мафиози. Ночью вы выбираете жертву вместе с мафией, а затем просыпаетесь отдельно и вычисляете комиссара. Цель — пережить горожан.',
  mafia: 'Каждую ночь вы выбираете жертву. Днём притворяйтесь мирным. Цель — пережить горожан.',
  doctor: 'Каждую ночь спасаете одного игрока. Можете спасти себя. Цель — уничтожить мафию.',
  detective: 'Каждую ночь проверяете одного игрока. Узнаёте, мафия он или нет. Цель — уничтожить мафию.',
  prostitute:
    'Вы знаете всю мафию и играете на её стороне. Днём притворяйтесь мирным и помогайте своим на голосовании. Цель — пережить горожан.',
  civilian: 'У вас нет ночных действий. Днём вы голосуете. Цель — вычислить и устранить мафию.',
};

export const MAFIA_ROLES: Role[] = ['mafia_don', 'mafia'];

export function isMafiaRole(role: Role | null | undefined): boolean {
  return !!role && MAFIA_ROLES.includes(role);
}

export const ALL_ROLES: Role[] = ['mafia_don', 'mafia', 'doctor', 'detective', 'prostitute', 'civilian'];

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ALL_ROLES as string[]).includes(value);
}
